import axios from "axios";
import React, { useEffect, useState } from "react";
interface NewsStructure {
  id: string;
  title: string;
  img: string;
  content: string;
  date: string;
  Gallery: string;
  category: string;
  tags: string;
  author: string;
}
const TopNews2 = () => {

  const api = process.env.REACT_APP_API_URL as string;
    
  
    const [newData, setNewData] = useState<NewsStructure[]>([]);
     useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await axios.get<NewsStructure[]>(
            `${api}/auth/news`
          );
  
        
          setNewData(response.data);
          
        } catch (error) {
          // console.error("Post Not Found:", error);
        }
      };
  
      fetchData();
    }, []);
    
    const topNews = [
    {
      image: "/src/images/top-news1.webp",
      text: "Hope, not despair, leads to success: Diya Kumari uplifts students...",
    },
    {
      image: "/src/images/top-news2.webp",
      text: "India will never be first to use Nukes: Prasad",
    },
    {
      image: "/src/images/top-news3.webp",
      text: "Sindoor Van: Where Earth echoes tales of valour",
    },
    {
      image: "/src/images/top-news4.webp",
      text: "Suresh Rawat kicks off water conservation drive in Bikaner...",
    },
    {
      image: "/src/images/top-news5.webp",
      text: "Satish Katka case: HC seeks case diary...",
    },
    {
      image: "/src/images/top-news6.webp",
      text: "Cong delegation meets ACB DG over case against Udailal...",
    },
    {
      image: "/src/images/top-news7.webp",
      text: "Kirodi Lal Meena leads crackdown on fake seed units...",
    },
    {
      image: "/src/images/top-news8.webp",
      text: "Shekhawat reviews monsoon preparedness",
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      {/* Top News */}
      <div>
        <h3 className="text-black py-2 border-b-2 border-gray-300 mb-2 font-bold text-2xl">
          TOP NEWS <span className="text-red-800">&gt;</span> 
        </h3>
        <ul className="text-sm border border-gray-300 items-center justify-center">
          {newData.map((item, index) => (
            <li
              key={index}
              className="p-2 border-b last:border-b-0 flex flex-col items-center gap-2 cursor-pointer"
            >
              <img
                src={`${api}/${item.img}`}
                alt={`top-${index}`}
                className="w-80 h-48 object-cover rounded-sm"
              />
              <span className="text-xl font-bold hover:text-red-800 items-center justify-center cursor-pointer" 
              onClick={()=>{
                window.location.href = `/news/${item.id}`
              }}
              >
                {item.title}
              </span>
              <hr />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TopNews2;
